import { NavigationCard } from "@/components/navigation-card";

export function ExploreGamesCard() {
  return (
    <NavigationCard
      title="Explore Games"
      splash="https://images.unsplash.com/photo-1500381209922-c8edf58341a9?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w1NDM2NzN8MHwxfHNlYXJjaHwxMjR8fHNleHxlbnwwfDB8fHwxNzQ1NTIyNzY3fDA&ixlib=rb-4.0.3&q=80&w=200"
      description="Explore all of the custom hand-crafted games made by the community."
      to="/explore-games"
    />
  );
}
